<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="colorPicker" :label="$lang.colorPicker" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="dark" :label="$lang.dark" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="icon" :label="$lang.icon" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="readonly" :label="$lang.readonly" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="8" sm24>
        <btn :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" :color-lightness="null" :class="['mb-4']" @click="execute" size="sm" block :disabled="index === sdtIns.length">{{ $lang.executeSampleCommand }}</btn>
      </flex-col>
      <flex-col :span="8" sm24>
        <btn :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" :color-lightness="null" :class="['mb-4']" @click="history" size="sm" block>{{ $lang.getHistory }}</btn>
      </flex-col>
      <flex-col :span="8" sm24>
        <btn :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" :color-lightness="null" :class="['mb-4']" @click="clear" size="sm" block>{{ $lang.clear }}</btn>
      </flex-col>
      <flex-col :span="24">
        <terminal :icon="icon" :color-picker="colorPicker" :readonly="readonly" :dark="dark" :ui-color="$root.colors.primary" :ui-color-lightness="$root.colors.bgColorLightness" @sdt-out="onSdtOut" :sdt-in="sdtIn" :prefix="prefix" ref="terminal" />
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageTerminal',
  data () {
    return {
      prefix: 'bcq@brandcompete ~ %',
      sdtIns: [],
      sdtIn: null,
      index: 0,
      icon: true,
      dark: true,
      colorPicker: true,
      readonly: false
    }
  },
  mixins: [
    methods
  ],
  watch: {
    dark () {
      this.pushCommand('dark')
    },
    colorPicker () {
      this.pushCommand('colorPicker')
    },
    readonly () {
      this.pushCommand('readonly')
    },
    icon () {
      this.pushCommand('icon')
    }
  },
  mounted () {
    this.getExternalData('terminal.json', 'sdtIns', 'GET', () => {
      this.execute()
    })
  },
  methods: {
    execute () {
      this.sdtIn = this.sdtIns[this.index]
      this.index++
    },
    onSdtOut ($event) {
      this.log('sdt-out', 'terminal', $event)
    },
    pushCommand (command) {
      this.sdtIn = {
        command: `${command}: ${this[command]}`
      }
    },
    clear () {
      console.log('clear')
      this.$refs['terminal'].clear()
      this.history()
    },
    history () {
      console.log('history', this.$refs['terminal'].history)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/terminal.vue